import Vue from 'vue'
import Router from 'vue-router'
import MessageBoard from '@/components/MessageBoard'
import Message from '@/components/Message'
import Timeline from '@/components/Timeline'
import Barrage from '@/components/Barrage'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    
    {
      path: '*',
      name: 'home',
      redirect: 'rescue',
      component: () => import('@/views/Home/index'),
      children: [
        {
          path: 'people',
          name: '逆行者',
          component: () => import('@/views/Home/people'),
          // meta: { title: '致敬逆行者' },
        },
        {
          path: 'rescue',
          name: '救援队',
          component: () => import('@/views/Home/rescue'),
          // meta: { title: '致敬逆行者' },
        }
      ]
    },
    {
      path: '/author',
      name: '授权',
      component: () => import('@/views/author/index'),
    },
    {
      path: '/MessageBoard',
      name: 'MessageBoard',
      component: MessageBoard
    },
    {
      path: '/Message',
      name: 'Message',
      component: Message
    },
    {
      path: '/Timeline',
      name: 'Timeline',
      component: Timeline
    },
    {
      path: '/Barrage',
      name: 'Barrage',
      component: Barrage
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js